/**
 * Created by Rajeshwarasethupathy on 07-02-2020.
 */

export class QuicktipsPosition {
  public static get hy(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 17.5,
      firstTimeEventsText1QTE: 19,
      firstTimeEventsText2QTE: 19,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,

      quickTipsContentTextQTE: 17,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 21,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 17,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 17,
      russianRouletteTextQTE: 22,
      rouletteRightQTE: 623,
      rouletteRightQTE3S: 623,
      TutorialsTextQTE: 19,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 20,
      FirstTimePlayerContentQSLineHeight: 20,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 18,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 19,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 20,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 20,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 25,
      CurrentTimeAndGameIDContentQS: 20,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 20,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 19,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 26,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 9.5,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 22,
      ChangeChipsTextQTB: 25,
      Pick5TextQTB: 25,
      Pick6TextQTB: 25,
      ClearTextQTB: 25,
      CTextQTB: 50,
      ConfirmTextQTB: 25,
      spaceTextQTB: 20,
      StandTextQTB: 25,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 25,
      doubleDownQTB: 25,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 25,
      //'CTextQTB': 40,
      rebetTextQTB: 25,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 22,
      RTextQTB: 50,
      yesTextQTB: 25,
      YTextQTB: 50,
      yesToAllTextQTB: 25,
      noTextQTB: 25,
      NTextQTB: 50,
      noToAllTextQTB: 25,
      XTextQTB: 35,
      russianRouletteTextQTB: 25,
      spaceText1QTB: 20,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 25,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 23,
      GameOverTextQTB: 25,

      The4NaturalsGameOverTextQTD: 17,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 117,
      rouletteRightQTD3S: 150,
      rouletteRightDisplay9QTD3S: 150,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 16,
      quickKeySpacelineHeight: 15,
      betLimitHeaderFontSize: 24,
      betLimitContentFontSize: 19,
      quickKeyChangeIconLeft: 480,
      ChangeUserInfoIconLeft: 480,
      quickKeyIconLeft: 520,
      changeQuickkeyTitle: 20,
      changeQuickkeyContent: 20,
    };
  }

  public static get 'zh-Hans'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 17,
      nextTextQTE: 17,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 20,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 565,
      rouletteRightQTE3S: 565,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 24,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 22,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 22,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 22,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 22,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 22,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 22,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 20,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 22,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 21,
      TutorialsTextQS: 26,
      TutorialsContentQS: 21,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 21,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 21,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 85,
      rouletteRightQTD3S: 110,
      rouletteRightDisplay9QTD3S: 110,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 545,
      ChangeUserInfoIconLeft: 545,
      quickKeyIconLeft: 570,
      changeQuickkeyTitle: 22,
      changeQuickkeyContent: 22,
    };
  }

  public static get 'zh-Hant'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 17,
      nextTextQTE: 17,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 20,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 530,
      rouletteRightQTE3S: 530,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 24,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 24,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 24,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 24,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 24,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 24,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 24,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 24,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 24,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 24,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 21,
      TutorialsTextQS: 26,
      TutorialsContentQS: 21,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 21,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 21,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 65,
      rouletteRightQTD3S: 85,
      rouletteRightDisplay9QTD3S: 85,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 545,
      ChangeUserInfoIconLeft: 545,
      quickKeyIconLeft: 570,
      changeQuickkeyTitle: 24,
      changeQuickkeyContent: 24,
    };
  }

  public static get cs(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 540,
      rouletteRightQTE3S: 540,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 22,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 22,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 22,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 22,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 19,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 22,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 20,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 22,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 18,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 70,
      rouletteRightQTD3S: 90,
      rouletteRightDisplay9QTD3S: 90,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 480,
      ChangeUserInfoIconLeft: 495,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get da(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 26,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 580,
      rouletteRightQTE3S: 580,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 19,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 20,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 20,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 20,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 90,
      rouletteRightQTD3S: 120,
      rouletteRightDisplay9QTD3S: 120,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 20,
      quickKeySpacelineHeight: '35',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 510,
      ChangeUserInfoIconLeft: 530,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get nl(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 18,
      firstTimeEventsText2QTE: 18,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 26,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 545,
      rouletteRightQTE3S: 545,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 19,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 22,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 26,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 20,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 75,
      rouletteRightQTD3S: 100,
      rouletteRightDisplay9QTD3S: 100,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 505,
      ChangeUserInfoIconLeft: 490,
      quickKeyIconLeft: 555,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get en(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 32,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 32,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 32,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 28,
      menuTextQTE: 28,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 556,
      rouletteRightQTE3S: 556,
      TutorialsTextQTE: 23,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 23,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 23,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 23,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 23,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 23,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 23,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 470,
      ChangeUserInfoIconLeft: 490,
      quickKeyIconLeft: 535,
      changeQuickkeyTitle: 23,
      changeQuickkeyContent: 23,
    };
  }

  public static get fi(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 22,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 556,
      rouletteRightQTE3S: 556,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 435,
      quickKeyQsLeft: 22,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 495,
      ChangeUserInfoIconLeft: 515,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get fr(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 13,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 512,
      rouletteRightQTE3S: 512,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 26,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 16,
      TutorialsTextQS: 26,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 26,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 70,
      rouletteRightDisplay9QTD3S: 70,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 455,
      ChangeUserInfoIconLeft: 470,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get de(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 19,
      firstTimeEventsText2QTE: 19,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 16,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 595,
      rouletteRightQTE3S: 595,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 20,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 20,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 20,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 20,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 20,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 20,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 20,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 28,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 105,
      rouletteRightQTD3S: 135,
      rouletteRightDisplay9QTD3S: 135,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 490,
      ChangeUserInfoIconLeft: 490,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get he(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 25,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 37,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 25,
      cancelTextQTE: 28,
      menuTextQTE: 28,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 27,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 471,
      rouletteRightQTE3S: 451,
      TutorialsTextQTE: 28,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 25,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 25,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 25,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 25,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 25,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 25,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 25,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 25,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 25,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 27,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 25,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 25,
      FirstTimePlayerContentQS: 22,
      TutorialsTextQS: 25,
      TutorialsContentQS: 22,
      VideoTutorialsTextQS: 25,
      VideoTutorialsContentQS: 22,
      ExperiencedPlayerTextQS: 25,
      ExperiencedPlayerContentQS: 22,
      DoNotShowAgainTextQS: 27,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 19,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 20,
      selectOneRadioImgLeft: 435,
      selectOnecheckedImgLeft: 410,
      selectOneUncheckedImgLeft: 414,
      selectOneDontShowContentLeft: 30,

      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 29,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 35,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 35,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 35,
      rouletteRightQTD3S: 49,
      rouletteRightDisplay9QTD3S: 63,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 19,
      quickKeySpacelineHeight: 30,
      betLimitHeaderFontSize: 34,
      betLimitContentFontSize: 28,
      quickKeyChangeIconLeft: 745,
      ChangeUserInfoIconLeft: 710,
      quickKeyIconLeft: 685,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get id(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 13,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 583,
      rouletteRightQTE3S: 583,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 27,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 19,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 16,
      TutorialsTextQS: 26,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 435,
      quickKeyQsLeft: 22,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 21,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 27,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 95,
      rouletteRightQTD3S: 125,
      rouletteRightDisplay9QTD3S: 125,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 515,
      ChangeUserInfoIconLeft: 515,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get it(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 520,
      rouletteRightQTE3S: 520,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 31,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 31,
      menuTitleQS: 31,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 31,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 31,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 31,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 31,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 31,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 31,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 31,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 31,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 31,
      PlaceYourBetsTextQS: 31,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 31,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 21,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 25,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 28,
      GameOverTextQTB: 30,
      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 60,
      rouletteRightQTD3S: 80,
      rouletteRightDisplay9QTD3S: 80,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 465,
      ChangeUserInfoIconLeft: 515,
      quickKeyIconLeft: 515,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get ja(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 20,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 515,
      rouletteRightQTE3S: 515,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 22,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 22,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 22,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 22,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 22,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 22,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 22,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 22,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 26,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 14,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 25,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 25,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 26,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 28,
      GameOverTextQTB: 30,
      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 75,
      rouletteRightDisplay9QTD3S: 75,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 13,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 505,
      ChangeUserInfoIconLeft: 505,
      quickKeyIconLeft: 540,
      changeQuickkeyTitle: 22,
      changeQuickkeyContent: 22,
    };
  }

  public static get ko(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 510,
      rouletteRightQTE3S: 510,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 24,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 23,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 25,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 25,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 23,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 18,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 15,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 30,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 30,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 28,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 28,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 50,
      rouletteRightQTD3S: 70,
      rouletteRightDisplay9QTD3S: 70,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 16,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 540,
      ChangeUserInfoIconLeft: 540,
      quickKeyIconLeft: 565,
      changeQuickkeyTitle: 24,
      changeQuickkeyContent: 24,
    };
  }

  public static get nb(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 540,
      rouletteRightQTE3S: 540,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 20,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 26,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 21,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 21,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 515,
      ChangeUserInfoIconLeft: 530,
      quickKeyIconLeft: 555,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get pl(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 556,
      rouletteRightQTE3S: 556,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 20,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 26,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 420,
      quickKeyQsLeft: 30,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 18,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 25,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 495,
      ChangeUserInfoIconLeft: 495,
      quickKeyIconLeft: 535,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get 'pt-BR'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 16,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 515,
      rouletteRightQTE3S: 515,
      TutorialsTextQTE: 20,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 25,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 75,
      rouletteRightDisplay9QTD3S: 75,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 490,
      ChangeUserInfoIconLeft: 510,
      quickKeyIconLeft: 535,
      changeQuickkeyTitle: 27,
      changeQuickkeyContent: 27,
    };
  }

  public static get ru(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 15,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 18,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 630,
      rouletteRightQTE3S: 630,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 29,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 26,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 24,
      FirstTimePlayerContentQS: 15,
      TutorialsTextQS: 24,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 24,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 24,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 29,
      PreviousTextQS: 29,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 29,
      noTextQS: 29,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 20,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 120,
      rouletteRightQTD3S: 160,
      rouletteRightDisplay9QTD3S: 160,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 475,
      ChangeUserInfoIconLeft: 450,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get es(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 17,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 510,
      rouletteRightQTE3S: 510,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 19,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 20,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 20,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 20,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 20,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 20,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 20,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 20,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 20,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 25,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 75,
      rouletteRightDisplay9QTD3S: 75,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 20,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 500,
      ChangeUserInfoIconLeft: 480,
      quickKeyIconLeft: 550,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get sv(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 22,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 21,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 537,
      rouletteRightQTE3S: 537,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 23,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 23,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 23,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 23,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 23,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 20,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 35,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 35,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 95,
      rouletteRightDisplay9QTD3S: 95,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 21,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 525,
      ChangeUserInfoIconLeft: 510,
      quickKeyIconLeft: 550,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get th(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 22,
      nextTextQTE: 22,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 28,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 630,
      rouletteRightQTE3S: 630,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 23,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 24,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 23,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 23,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 23,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 20,
      TutorialsTextQS: 26,
      TutorialsContentQS: 20,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 20,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 20,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 22,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 120,
      rouletteRightQTD3S: 155,
      rouletteRightDisplay9QTD3S: 155,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 18.5,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 545,
      ChangeUserInfoIconLeft: 535,
      quickKeyIconLeft: 575,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get tr(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 25,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 540,
      rouletteRightQTE3S: 540,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 27,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 27,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 22,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 26,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 70,
      rouletteRightQTD3S: 95,
      rouletteRightDisplay9QTD3S: 95,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 500,
      ChangeUserInfoIconLeft: 505,
      quickKeyIconLeft: 550,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get vi(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 23,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 512,
      rouletteRightQTE3S: 512,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 20,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 20,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 20,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 20,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 20,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 23,
      CurrentTimeAndGameIDContentQS: 19,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 20,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 20,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 16,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 30,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 30,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 26,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 70,
      rouletteRightDisplay9QTD3S: 70,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 17,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 500,
      ChangeUserInfoIconLeft: 440,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 25,
      changeQuickkeyContent: 25,
    };
  }

  public static get ar(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 28,
      firstTimeEventsText2QTE: 28,
      firstTimeEventsNextTextQTE: 30,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 28,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 32,
      firstTimeEventsContentTextQTE: 26,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 30,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 471,
      rouletteRightQTE3S: 451,
      TutorialsTextQTE: 28,

      WelcomeTitleQS: 35,
      WelcomeContentQS: 28,
      firstTimeEventsNextTextQS: 35,
      menuTitleQS: 35,
      menuContentQS: 28,
      FeaturesFunctionsTitleQS: 35,
      FeaturesFunctionsContentQS: 28,
      ChangeChipsTitleQS: 35,
      ChangeChipsContentQS: 28,
      tutorialsTitleQS: 35,
      tutorialsContentQS: 28,
      HelpingHandTitleQS: 35,
      HelpingHandContentQS: 28,
      FirstTimeEventsTitleQS: 35,
      FirstTimeEventsContentQS: 28,
      QuickKeysTitleQS: 35,
      QuickKeysContentQS: 28,
      CurrentTimeAndGameIDTitleQS: 35,
      CurrentTimeAndGameIDContentQS: 28,
      TableLimitsTitleQS: 35,
      TableLimitsContentQS: 28,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 35,
      PlaceYourBetsTextQS: 35,
      PlaceYourBetsContentQS: 28,
      SelectOneTextQS: 35,
      FirstTimePlayerTextQS: 28,
      FirstTimePlayerContentQS: 22,
      TutorialsTextQS: 28,
      TutorialsContentQS: 22,
      VideoTutorialsTextQS: 28,
      VideoTutorialsContentQS: 22,
      ExperiencedPlayerTextQS: 28,
      ExperiencedPlayerContentQS: 22,
      DoNotShowAgainTextQS: 24,
      //'PreviousTextQS': ,
      nextTextQS: 35,
      PreviousTextQS: 35,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 18.5,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 20,
      selectOneRadioImgLeft: 435,
      selectOnecheckedImgLeft: 410,
      selectOneUncheckedImgLeft: 414,
      selectOneDontShowContentLeft: 30,

      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 30,
      PlaceYourBetsTextQTB: 35,
      ChangeChipsTextQTB: 35,
      Pick5TextQTB: 35,
      Pick6TextQTB: 35,
      ClearTextQTB: 35,
      CTextQTB: 50,
      ConfirmTextQTB: 35,
      spaceTextQTB: 35,
      StandTextQTB: 35,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 35,
      doubleDownQTB: 35,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 35,
      //'CTextQTB': 40,
      rebetTextQTB: 35,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 35,
      RTextQTB: 50,
      yesTextQTB: 35,
      YTextQTB: 50,
      yesToAllTextQTB: 35,
      noTextQTB: 35,
      NTextQTB: 50,
      noToAllTextQTB: 35,
      XTextQTB: 50,
      russianRouletteTextQTB: 35,
      spaceText1QTB: 35,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 35,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 35,
      GameOverTextQTB: 35,

      The4NaturalsGameOverTextQTD: 32,
      content3ScoreTextQTD: 32,
      GameContinuesTextQTD: 32,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 35,
      rouletteRightQTD3S: 49,
      rouletteRightDisplay9QTD3S: 67,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 26,
      quickKeySpacelineHeight: 18,
      betLimitHeaderFontSize: 35,
      betLimitContentFontSize: 30,
      quickKeyChangeIconLeft: 725,
      ChangeUserInfoIconLeft: 710,
      quickKeyIconLeft: 690,
      changeQuickkeyTitle: 35,
      changeQuickkeyContent: 35,
    };
  }

  public static get bg(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 23,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 635,
      rouletteRightQTE3S: 635,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 32,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 25,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 125,
      rouletteRightQTD3S: 160,
      rouletteRightDisplay9QTD3S: 160,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 35,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 490,
      ChangeUserInfoIconLeft: 440,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get ee(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 18,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 22,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 590,
      rouletteRightQTE3S: 590,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 22,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 20,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 20,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 18,
      CurrentTimeAndGameIDTitleQS: 24,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 22,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 22,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 26,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 96,
      rouletteRightQTD3S: 130,
      rouletteRightDisplay9QTD3S: 130,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 510,
      ChangeUserInfoIconLeft: 495,
      quickKeyIconLeft: 560,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get ge(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 20,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 570,
      rouletteRightQTE3S: 556,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 19,
      welcomeContentQsLineHeight: 26,
      FirstTimePlayerContentQSLineHeight: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 27,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 29,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 22,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 26,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 20,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 23,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 90,
      rouletteRightQTD3S: 115,
      rouletteRightDisplay9QTD3S: 115,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 25,
      betLimitContentFontSize: 21,
      quickKeyChangeIconLeft: 425,
      ChangeUserInfoIconLeft: 455,
      quickKeyIconLeft: 505,
      changeQuickkeyTitle: 25,
      changeQuickkeyContent: 25,
    };
  }

  public static get gr(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 18,
      firstTimeEventsText2QTE: 18,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 17,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 18,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 19.5,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 570,
      rouletteRightQTE3S: 570,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 19,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 19,
      FeaturesFunctionsTitleQS: 26,
      FeaturesFunctionsContentQS: 19,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 19,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 19,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 19,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 19,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 19,
      CurrentTimeAndGameIDTitleQS: 22,
      CurrentTimeAndGameIDContentQS: 19,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 19,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 19,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 21,
      FirstTimePlayerContentQS: 16,
      TutorialsTextQS: 21,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 21,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 21,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 24,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 23,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 25,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 27,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 90,
      rouletteRightQTD3S: 115,
      rouletteRightDisplay9QTD3S: 115,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 500,
      ChangeUserInfoIconLeft: 505,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 25,
      changeQuickkeyContent: 25,
    };
  }

  public static get 'hi-IN'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 620,
      rouletteRightQTE3S: 620,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 23,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 23,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 23,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 23,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 23,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 22,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 115,
      rouletteRightQTD3S: 150,
      rouletteRightDisplay9QTD3S: 150,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 530,
      ChangeUserInfoIconLeft: 486,
      quickKeyIconLeft: 550,
      changeQuickkeyTitle: 23,
      changeQuickkeyContent: 23,
    };
  }

  public static get hu(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 19,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 520,
      rouletteRightQTE3S: 520,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 20,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 27,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 16,
      TutorialsTextQS: 26,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 55,
      rouletteRightQTD3S: 70,
      rouletteRightDisplay9QTD3S: 70,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 480,
      ChangeUserInfoIconLeft: 466,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 27,
      changeQuickkeyContent: 27,
    };
  }

  public static get lt(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 530,
      rouletteRightQTE3S: 530,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 26,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 26,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 65,
      rouletteRightQTD3S: 85,
      rouletteRightDisplay9QTD3S: 85,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 505,
      ChangeUserInfoIconLeft: 505,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get kh(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 21,
      playNowTextQTE: 19,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 18,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 545,
      rouletteRightQTE3S: 545,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 32,
      WelcomeContentQS: 21,
      welcomeContentQsLineHeight: 33,
      firstTimeEventsNextTextQS: 32,
      menuTitleQS: 32,
      menuContentQS: 23,
      FeaturesFunctionsTitleQS: 32,
      FeaturesFunctionsContentQS: 23,
      ChangeChipsTitleQS: 32,
      ChangeChipsContentQS: 23,
      tutorialsTitleQS: 32,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 32,
      HelpingHandContentQS: 23,
      FirstTimeEventsTitleQS: 32,
      FirstTimeEventsContentQS: 23,
      QuickKeysTitleQS: 32,
      QuickKeysContentQS: 23,
      CurrentTimeAndGameIDTitleQS: 32,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 32,
      TableLimitsContentQS: 23,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 32,
      PlaceYourBetsTextQS: 32,
      PlaceYourBetsContentQS: 23,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 25,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 25,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 25,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 25,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 14,
      //'PreviousTextQS': ,
      nextTextQS: 32,
      PreviousTextQS: 32,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 32,
      noTextQS: 32,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 19,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 35,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 35,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 70,
      rouletteRightQTD3S: 93,
      rouletteRightDisplay9QTD3S: 93,
      greenRedLightTitleTextTopQTD: 9,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 17,
      quickKeySpacelineHeight: 35,
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 535,
      ChangeUserInfoIconLeft: 535,
      quickKeyIconLeft: 555,
      changeQuickkeyTitle: 21,
      changeQuickkeyContent: 21,
    };
  }

  public static get lv(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 20,
      firstTimeEventsText2QTE: 20,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 16.5,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 570,
      rouletteRightQTE3S: 570,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 28,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 85,
      rouletteRightQTD3S: 115,
      rouletteRightDisplay9QTD3S: 115,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 520,
      ChangeUserInfoIconLeft: 520,
      quickKeyIconLeft: 555,
      changeQuickkeyTitle: 27,
      changeQuickkeyContent: 27,
    };
  }

  public static get mt(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 26,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 18,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 21,
      playersNaturalZeroTitleQTE: 21,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 545,
      rouletteRightQTE3S: 545,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 27,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 27,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 18,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 27,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 27,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 475,
      ChangeUserInfoIconLeft: 530,
      quickKeyIconLeft: 530,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get my(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 14.5,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 605,
      rouletteRightQTE3S: 605,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 20,
      CurrentTimeAndGameIDTitleQS: 25,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 16,
      TutorialsTextQS: 26,
      TutorialsContentQS: 16,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 16,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 16,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 105,
      rouletteRightQTD3S: 140,
      rouletteRightDisplay9QTD3S: 140,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 500,
      ChangeUserInfoIconLeft: 500,
      quickKeyIconLeft: 540,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get ph(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 28,
      firstTimeEventsText1QTE: 17,
      firstTimeEventsText2QTE: 17,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 18,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 610,
      rouletteRightQTE3S: 610,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 22,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 22,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 22,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 22,
      CurrentTimeAndGameIDTitleQS: 20.5,
      CurrentTimeAndGameIDContentQS: 22,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 22,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 15,
      TutorialsTextQS: 26,
      TutorialsContentQS: 15,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 15,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 15,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,

      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 420,
      quickKeyQsLeft: 30,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 21,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 110,
      rouletteRightQTD3S: 145,
      rouletteRightDisplay9QTD3S: 145,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 475,
      ChangeUserInfoIconLeft: 505,
      quickKeyIconLeft: 545,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get ro(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 27,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 17,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 22,
      playersNaturalZeroTitleQTE: 22,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 553,
      rouletteRightQTE3S: 553,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 19,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 27,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 27,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 32,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 17,
      TutorialsTextQS: 22,
      TutorialsContentQS: 17,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 17,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 17,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 505,
      ChangeUserInfoIconLeft: 545,
      quickKeyIconLeft: 560,
      changeQuickkeyTitle: 27,
      changeQuickkeyContent: 27,
    };
  }

  public static get si(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 19,
      firstTimeEventsText2QTE: 19,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 23,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 553,
      rouletteRightQTE3S: 553,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 18,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 18,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 28,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 475,
      ChangeUserInfoIconLeft: 485,
      quickKeyIconLeft: 525,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get sk(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 28,
      firstTimeEventsText1QTE: 21,
      firstTimeEventsText2QTE: 21,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 24,
      playNowTextQTE: 19,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 19,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 543,
      rouletteRightQTE3S: 543,
      TutorialsTextQTE: 21,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 28,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 26,
      PreviousTextQS: 26,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 22,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 19,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 25,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 80,
      rouletteRightQTD3S: 105,
      rouletteRightDisplay9QTD3S: 105,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 450,
      ChangeUserInfoIconLeft: 500,
      quickKeyIconLeft: 505,
      changeQuickkeyTitle: 28,
      changeQuickkeyContent: 28,
    };
  }

  public static get 'sr-RS'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 25,
      playNowTextQTE: 20,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 24,
      playersNaturalZeroTitleQTE: 24,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 564,
      rouletteRightQTE3S: 564,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 22,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 21,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 18,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 85,
      rouletteRightQTD3S: 110,
      rouletteRightDisplay9QTD3S: 110,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 505,
      ChangeUserInfoIconLeft: 475,
      quickKeyIconLeft: 560,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }

  public static get 'ta-IN'(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 26,
      firstTimeEventsText1QTE: 16,
      firstTimeEventsText2QTE: 16,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 26,
      quickTipsContentTextQTE: 18,
      playNowTextQTE: 12,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 15,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 24,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.2,
      quicktipsHandranksTextPortrait: 5,
      newGameTextQTE: 20,
      gameContinuesTextQTE: 20,
      gameOverTextQTE: 20,
      doNotShowAgainTextminus1QTE: 12.5,
      colorCardInsuranceTexyQTE: 22,
      playersNaturalZeroTitleQTE: 18,
      doNotShowAgainTextQTE: 13,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 692,
      rouletteRightQTE3S: 692,
      TutorialsTextQTE: 15,

      WelcomeTitleQS: 21,
      WelcomeContentQS: 15,
      firstTimeEventsNextTextQS: 21,
      menuTitleQS: 21,
      menuContentQS: 16,
      FeaturesFunctionsTitleQS: 18,
      FeaturesFunctionsContentQS: 16,
      ChangeChipsTitleQS: 21,
      ChangeChipsContentQS: 16,
      tutorialsTitleQS: 21,
      tutorialsContentQS: 16,
      HelpingHandTitleQS: 21,
      HelpingHandContentQS: 16,
      FirstTimeEventsTitleQS: 21,
      FirstTimeEventsContentQS: 16,
      QuickKeysTitleQS: 21,
      QuickKeysContentQS: 16,
      CurrentTimeAndGameIDTitleQS: 18,
      CurrentTimeAndGameIDContentQS: 16,
      TableLimitsTitleQS: 21,
      TableLimitsContentQS: 16,
      MINTextQS: 14,
      MAXTextQS: 14,
      BetBarTitleQS: 21,
      PlaceYourBetsTextQS: 21,
      PlaceYourBetsContentQS: 16,
      SelectOneTextQS: 21,
      FirstTimePlayerTextQS: 20,
      FirstTimePlayerContentQS: 12,
      TutorialsTextQS: 20,
      TutorialsContentQS: 12,
      VideoTutorialsTextQS: 20,
      VideoTutorialsContentQS: 12,
      ExperiencedPlayerTextQS: 20,
      ExperiencedPlayerContentQS: 12,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 21,
      PreviousTextQS: 21,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 21,
      noTextQS: 21,

      HTextQS: 20,
      STextQS: 20,
      DTextQS: 20,
      Text1QS: 25,
      spaceTextQS: 12,
      YTextQS: 20,
      NTextQS: 20,
      XTextQS: 20,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 17,
      PlaceYourBetsTextQTB: 18,
      ChangeChipsTextQTB: 25,
      Pick5TextQTB: 25,
      Pick6TextQTB: 25,
      ClearTextQTB: 25,
      CTextQTB: 50,
      ConfirmTextQTB: 25,
      spaceTextQTB: 25,
      StandTextQTB: 25,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 25,
      doubleDownQTB: 18,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 25,
      //'CTextQTB': 40,
      rebetTextQTB: 25,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 21,
      RTextQTB: 50,
      yesTextQTB: 25,
      YTextQTB: 50,
      yesToAllTextQTB: 25,
      noTextQTB: 25,
      NTextQTB: 50,
      noToAllTextQTB: 23,
      XTextQTB: 50,
      russianRouletteTextQTB: 25,
      spaceText1QTB: 25,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 20,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 18,
      GameOverTextQTB: 25,

      The4NaturalsGameOverTextQTD: 18,
      content3ScoreTextQTD: 18,
      GameContinuesTextQTD: 18,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 150,
      rouletteRightQTD3S: 200,
      rouletteRightDisplay9QTD3S: 200,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 10.4,
      quickKeySpacelineHeight: 37,
      betLimitHeaderFontSize: 21,
      betLimitContentFontSize: 17,
      quickKeyChangeIconLeft: 455,
      ChangeUserInfoIconLeft: 470,
      quickKeyIconLeft: 510,
      changeQuickkeyTitle: 20,
      changeQuickkeyContent: 20,
    };
  }

  public static get ua(): translateFontProp {
    return {
      firstTimeEventsTitleQTE: 32,
      firstTimeEventsText1QTE: 22,
      firstTimeEventsText2QTE: 22,
      firstTimeEventsNextTextQTE: 26,
      PreviousTextQTE: 26,
      nextTextQTE: 26,
      finishedTextQTE: 28,
      quickTipsContentTextQTE: 22,
      playNowTextQTE: 17,
      firstTimeEventsTextQTE: 27,
      firstTimeEventsContentTextQTE: 20,
      cancelTextQTE: 22,
      menuTextQTE: 22,
      gameStatusTextQTE: 32,
      gameStatusHHQTE: 26,
      quicktipsHandranksText: 1.7,
      quicktipsHandranksTextPortrait: 5.3,
      newGameTextQTE: 26,
      gameContinuesTextQTE: 26,
      gameOverTextQTE: 26,
      doNotShowAgainTextminus1QTE: 18,
      colorCardInsuranceTexyQTE: 22,
      playersNaturalZeroTitleQTE: 22,
      doNotShowAgainTextQTE: 20,
      whiteCardInsuranceTextQTE: 24,
      russianRouletteTextQTE: 24,
      rouletteRightQTE: 580,
      rouletteRightQTE3S: 580,
      TutorialsTextQTE: 22,

      WelcomeTitleQS: 30,
      WelcomeContentQS: 21,
      firstTimeEventsNextTextQS: 30,
      menuTitleQS: 30,
      menuContentQS: 21,
      FeaturesFunctionsTitleQS: 30,
      FeaturesFunctionsContentQS: 21,
      ChangeChipsTitleQS: 30,
      ChangeChipsContentQS: 21,
      tutorialsTitleQS: 30,
      tutorialsContentQS: 21,
      HelpingHandTitleQS: 30,
      HelpingHandContentQS: 21,
      FirstTimeEventsTitleQS: 30,
      FirstTimeEventsContentQS: 21,
      QuickKeysTitleQS: 30,
      QuickKeysContentQS: 21,
      CurrentTimeAndGameIDTitleQS: 30,
      CurrentTimeAndGameIDContentQS: 21,
      TableLimitsTitleQS: 30,
      TableLimitsContentQS: 20,
      MINTextQS: 22,
      MAXTextQS: 22,
      BetBarTitleQS: 30,
      PlaceYourBetsTextQS: 30,
      PlaceYourBetsContentQS: 21,
      SelectOneTextQS: 30,
      FirstTimePlayerTextQS: 26,
      FirstTimePlayerContentQS: 19,
      TutorialsTextQS: 26,
      TutorialsContentQS: 19,
      VideoTutorialsTextQS: 26,
      VideoTutorialsContentQS: 19,
      ExperiencedPlayerTextQS: 26,
      ExperiencedPlayerContentQS: 19,
      DoNotShowAgainTextQS: 18,
      //'PreviousTextQS': ,
      nextTextQS: 30,
      PreviousTextQS: 30,
      //'nextTextQS': ,
      //'DoNotShowAgainTextQS': ,
      yesTextQS: 30,
      noTextQS: 30,

      HTextQS: 25,
      STextQS: 25,
      DTextQS: 25,
      Text1QS: 25,
      spaceTextQS: 25,
      YTextQS: 25,
      NTextQS: 25,
      XTextQS: 25,
      Text9QS: 25,
      selectOneContentLeft: 64,
      selectOneRadioImgLeft: 6,
      selectOnecheckedImgLeft: 0,
      selectOneUncheckedImgLeft: 4,
      selectOneDontShowContentLeft: 40,
      welcomeContentQsWidth: 330,
      welcomeContentQsLeft: 60,

      menuContentQsWidth: 484,
      menuContentQsLeft: 0,

      featuresContentQsWidth: 483,
      featuresContentQsLeft: 0,

      changeChipQsWidth: 483,
      changeChipQsLeft: 0,

      tutorialQsWidth: 483,
      tutorialQsLeft: 0,

      helpingHandQsWidth: 483,
      helpingHandQsLeft: 0,

      quicktipsQsWidth: 483,
      quicktipsQsLeft: 0,

      quickKeyQsWidth: 483,
      quickKeyQsLeft: 0,

      currentTimeQsWidth: 482,
      currentTimeQsLeft: 0,

      tableLimitsQsWidth: 496,
      tableLimitsQsLeft: 0,

      placeYourBetQswidth: 489,
      placeYourBetQsLeft: 0,

      DontShowThisAgainTextQTB: 20,
      PlaceYourBetsTextQTB: 30,
      ChangeChipsTextQTB: 30,
      Pick5TextQTB: 30,
      Pick6TextQTB: 30,
      ClearTextQTB: 30,
      CTextQTB: 50,
      ConfirmTextQTB: 30,
      spaceTextQTB: 40,
      StandTextQTB: 30,
      STextQTB: 45,
      //'STextQTB': 40,
      //'STextQTB': 40,
      //'STextQTB': 40,
      hitTextQTB: 30,
      doubleDownQTB: 30,
      //'HTextQTB': ,
      //'hitTextQTB': ,
      HTextQTB: 50,
      DTextQTB: 50,
      //'DTextQTB': ,
      newBetTextQTB: 30,
      //'CTextQTB': 40,
      rebetTextQTB: 30,
      //'spaceTextQTB': 33,
      doubleBetTextQTB: 30,
      RTextQTB: 50,
      yesTextQTB: 30,
      YTextQTB: 50,
      yesToAllTextQTB: 30,
      noTextQTB: 30,
      NTextQTB: 50,
      noToAllTextQTB: 30,
      XTextQTB: 50,
      russianRouletteTextQTB: 30,
      spaceText1QTB: 40,
      //'yesTextQTB': 30,
      //'YTextQTB': 50,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'YTextQTB': ,
      //'noTextQTB': 30,
      //'NTextQTB': 50,
      //'NTextQTB': ,
      //'NTextQTB': ,
      //'NTextQTB': ,
      splitYourHandTextQTB: 30,
      //'spaceText1QTB': ,
      WaitingForOtherPlayersTextQTB: 30,
      GameOverTextQTB: 30,

      The4NaturalsGameOverTextQTD: 24,
      content3ScoreTextQTD: 24,
      GameContinuesTextQTD: 24,
      MINTextQTD: 30,
      MAXTextQTD: 30,
      rouletteRightQTD: 90,
      rouletteRightQTD3S: 120,
      rouletteRightDisplay9QTD3S: 120,
      greenRedLightTitleTextTopQTD: 5,

      quickKeyFontSize: 24,
      quickKeySpaceFontSize: 24,
      quickKeySpacelineHeight: 'normal',
      betLimitHeaderFontSize: 30,
      betLimitContentFontSize: 24,
      quickKeyChangeIconLeft: 490,
      ChangeUserInfoIconLeft: 490,
      quickKeyIconLeft: 540,
      changeQuickkeyTitle: 30,
      changeQuickkeyContent: 30,
    };
  }
}

interface translateFontProp {
  firstTimeEventsTitleQTE;
  firstTimeEventsText1QTE;
  firstTimeEventsText2QTE;
  firstTimeEventsNextTextQTE;
  PreviousTextQTE;
  nextTextQTE;
  finishedTextQTE;
  quickTipsContentTextQTE;
  playNowTextQTE;
  firstTimeEventsTextQTE;
  firstTimeEventsContentTextQTE;
  cancelTextQTE;
  menuTextQTE;
  gameStatusTextQTE;
  gameStatusHHQTE;
  quicktipsHandranksText;
  quicktipsHandranksTextPortrait;
  newGameTextQTE;
  gameContinuesTextQTE;
  gameOverTextQTE;
  doNotShowAgainTextminus1QTE;
  colorCardInsuranceTexyQTE;
  playersNaturalZeroTitleQTE;
  doNotShowAgainTextQTE;
  whiteCardInsuranceTextQTE;
  russianRouletteTextQTE;
  rouletteRightQTE;
  rouletteRightQTE3S;
  TutorialsTextQTE;

  WelcomeTitleQS;
  WelcomeContentQS;
  firstTimeEventsNextTextQS;
  menuTitleQS;
  menuContentQS;
  FeaturesFunctionsTitleQS;
  FeaturesFunctionsContentQS;
  ChangeChipsTitleQS;
  ChangeChipsContentQS;
  tutorialsTitleQS;
  tutorialsContentQS;
  HelpingHandTitleQS;
  HelpingHandContentQS;
  FirstTimeEventsTitleQS;
  FirstTimeEventsContentQS;
  QuickKeysTitleQS;
  QuickKeysContentQS;
  CurrentTimeAndGameIDTitleQS;
  CurrentTimeAndGameIDContentQS;
  TableLimitsTitleQS;
  TableLimitsContentQS;
  MINTextQS;
  MAXTextQS;
  BetBarTitleQS;
  PlaceYourBetsTextQS;
  PlaceYourBetsContentQS;
  SelectOneTextQS;
  FirstTimePlayerTextQS;
  FirstTimePlayerContentQS;
  TutorialsTextQS;
  TutorialsContentQS;
  VideoTutorialsTextQS;
  VideoTutorialsContentQS;
  ExperiencedPlayerTextQS;
  ExperiencedPlayerContentQS;
  DoNotShowAgainTextQS;
  //'PreviousTextQS': ,
  nextTextQS;
  PreviousTextQS;
  //'nextTextQS': ,
  //'DoNotShowAgainTextQS': ,
  yesTextQS;
  noTextQS;

  HTextQS;
  STextQS;
  DTextQS;
  Text1QS;
  spaceTextQS;
  YTextQS;
  NTextQS;
  XTextQS;
  Text9QS;

  selectOneContentLeft;
  selectOneRadioImgLeft;
  selectOnecheckedImgLeft;
  selectOneUncheckedImgLeft;
  selectOneDontShowContentLeft;

  welcomeContentQsWidth;
  welcomeContentQsLeft;
  welcomeContentQsLineHeight?; // added only in ge,kh
  FirstTimePlayerContentQSLineHeight?; // added only in ge,kh

  menuContentQsWidth;
  menuContentQsLeft;

  featuresContentQsWidth;
  featuresContentQsLeft;

  changeChipQsWidth;
  changeChipQsLeft;

  tutorialQsWidth;
  tutorialQsLeft;

  helpingHandQsWidth;
  helpingHandQsLeft;

  quicktipsQsWidth;
  quicktipsQsLeft;

  quickKeyQsWidth;
  quickKeyQsLeft;

  currentTimeQsWidth;
  currentTimeQsLeft;

  tableLimitsQsWidth;
  tableLimitsQsLeft;

  placeYourBetQswidth;
  placeYourBetQsLeft;

  DontShowThisAgainTextQTB;
  PlaceYourBetsTextQTB;
  ChangeChipsTextQTB;
  Pick5TextQTB;
  Pick6TextQTB;
  ClearTextQTB;
  CTextQTB;
  ConfirmTextQTB;
  spaceTextQTB;
  StandTextQTB;
  STextQTB;
  //STextQTB
  //STextQTB
  //STextQTB
  hitTextQTB;
  doubleDownQTB;
  HTextQTB;
  //hitTextQTB
  //HTextQTB
  DTextQTB;
  //DTextQTB
  newBetTextQTB;
  //CTextQTB
  rebetTextQTB;
  //spaceTextQTB
  doubleBetTextQTB;
  RTextQTB;
  yesTextQTB;
  YTextQTB;
  yesToAllTextQTB;
  noTextQTB;
  NTextQTB;
  noToAllTextQTB;
  XTextQTB;
  russianRouletteTextQTB;
  //spaceTextQTB
  //yesTextQTB
  //YTextQTB
  //YTextQTB
  //YTextQTB
  //YTextQTB
  //noTextQTB
  //NTextQTB
  //NTextQTB
  //NTextQTB
  //NTextQTB
  splitYourHandTextQTB;
  spaceText1QTB;
  //spaceTextQTB
  WaitingForOtherPlayersTextQTB;
  GameOverTextQTB;

  The4NaturalsGameOverTextQTD;
  content3ScoreTextQTD;
  GameContinuesTextQTD;
  MINTextQTD;
  MAXTextQTD;
  rouletteRightQTD;
  rouletteRightQTD3S;
  rouletteRightDisplay9QTD3S;
  greenRedLightTitleTextTopQTD;

  quickKeyFontSize;
  quickKeySpaceFontSize;
  quickKeySpacelineHeight;

  betLimitHeaderFontSize;
  betLimitContentFontSize;

  quickKeyChangeIconLeft;
  ChangeUserInfoIconLeft;
  quickKeyIconLeft;
  changeQuickkeyTitle;
  changeQuickkeyContent;
}
